export default __webpack_public_path__ + "media/ca2dd9c156dfefaa97cfb9671f46fdb060ec077873ff4d93c98865f6fde2fdbe.svg";